import React from 'react'
import { RelatedContent } from './RelatedContent'
import { ContentDataDefinitionLoader } from '@news-mono/web-common'
import { createRegisterableComponentWithData } from '@news-mono/web-common'
import { isPublicationCardItem } from '@news-mono/web-common'

export interface RelatedContentRegistrationProps {
    title?: string
}

export const RelatedContentRegistration = createRegisterableComponentWithData(
    'related-content',
    ContentDataDefinitionLoader,
    ({ title }: RelatedContentRegistrationProps, data, services) => {
        if (data.loaded) {
            const publications = data.result.publications.filter(
                isPublicationCardItem,
            )

            if (publications.length) {
                return (
                    <RelatedContent
                        items={publications}
                        title={title}
                        onEvent={services.onEvent}
                    />
                )
            }
        }

        return null
    },
)
